import { render, staticRenderFns } from "./ArticlePicture.vue?vue&type=template&id=2bba2eae&scoped=true&"
import script from "./ArticlePicture.vue?vue&type=script&lang=js&"
export * from "./ArticlePicture.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePicture.vue?vue&type=style&index=0&id=2bba2eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba2eae",
  null
  
)

export default component.exports